export const getLast6Months = (monthList = []) => {
    let sorted = monthList.sort((a, b) => {
        let m1 = a.split("-");
        let m2 = b.split("-");

        if (Number(m1[0]) !== Number(m2[0])) return (Number(m2[0]) - Number(m1[0]));
        else return (Number(m2[1]) - Number(m1[1]));
    });

    return sorted.splice(0, 6);
}

export const getCSVDownload = (orders) => {
    const headers = ["Date", "Order No.", "Source", "Driver", "Distance", "Third Party Delivery Fee", "Third Party Tips", "Third Party Processing Fee", "Regulatory Fee", "Third Party Billable Amount", "Status", "Third Party Reference"];
    let rowString = headers.join(",");
    rowString += "\n";
    orders.forEach(order => {
        let row = [];
        let date = new Date(order.placementTime).toLocaleDateString('en', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
        date = date.replace(",", " ");
        row.push(date, order.orderNo, order.source, order.driver, order.distance, twoDigit(order.deliveryFee), twoDigit(order.tips), twoDigit(order.processingFee), twoDigit(order.regulatoryFee), twoDigit(order.totalBill), order.status, order.thirdPartyReference);
        let newRow = row.join(",");
        rowString += newRow + "\r\n";
    });
    return rowString;
}

const twoDigit = (val) => {
    if (isNaN(Number(val))) {
        return val;
    }
    return Number(val).toFixed(2);
}
